import errors from './errors/index.js';
import translation from './translation/index.js';
const zhCN = Object.freeze({
    translation,
    errors,
});
export default zhCN;
